var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContractRedliningOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 14H13V12H9V14ZM9 10H16V8H9V10ZM6 6H16V4H6V6ZM5.625 19C4.30833 19 3.1875 18.5375 2.2625 17.6125C1.3375 16.6875 0.875 15.5667 0.875 14.25C0.875 13.3 1.12083 12.45 1.6125 11.7C2.10417 10.95 2.75 10.3833 3.55 10H1V8H7V14H5V11.575C4.38333 11.7083 3.875 12.025 3.475 12.525C3.075 13.025 2.875 13.6 2.875 14.25C2.875 15.0167 3.14583 15.6667 3.6875 16.2C4.22917 16.7333 4.875 17 5.625 17V19ZM9 18V16H18V2H4V6H2V2C2 1.45 2.19583 0.979167 2.5875 0.5875C2.97917 0.195833 3.45 0 4 0H18C18.55 0 19.0208 0.195833 19.4125 0.5875C19.8042 0.979167 20 1.45 20 2V16C20 16.55 19.8042 17.0208 19.4125 17.4125C19.0208 17.8042 18.55 18 18 18H9Z",
    fill: "#3474E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractRedliningOutlined);
export default __webpack_public_path__ + "static/media/contractRedliningOutlined.e4a3bc5535c85dbafa66fcc2bbb447c0.svg";
export { ForwardRef as ReactComponent };